import { render, staticRenderFns } from "./shipper_credit_list.vue?vue&type=template&id=03ec3398&scoped=true&"
import script from "./shipper_credit_list.vue?vue&type=script&lang=js&"
export * from "./shipper_credit_list.vue?vue&type=script&lang=js&"
import style0 from "./shipper_credit_list.vue?vue&type=style&index=0&id=03ec3398&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ec3398",
  null
  
)

export default component.exports